import React from "react";
import Projects from "../Projects/Projects";

const staticProjectsList = [
  {
    id: "allProjects",
    displayText: "All My Projects",
    imageUrl:
      "https://d1tgh8fmlzexmh.cloudfront.net/ccbp-static-website/software-developer-img.png",
    gitHubUrl: "https://github.com/harikrishnaalvala/my-projects.git",
    liveDemoUrl: "https://hmyp.ccbp.tech/",
  },
];

const StaticProjects = () => <Projects projectsList={staticProjectsList} />;

export default StaticProjects;
